import { useContext } from "react";
import AppContext from "../context/AppContext";
import AppSettings from "../AppSettings";

export default function useCustomPartPrice() {
  const context = useContext(AppContext);
  const { token } = context;


  async function fetchGasketPrice(gasketDetails){
    const options = createClientOptions("POST", gasketDetails);
    const url = AppSettings.ApiCustomGasketPrice;

    const res = await fetch(url, options);
    await handleError(res);
    const data = await res.json();
    return data;
  }

  async function fetchWirePrice(wireDetails){
    try{
      const options = createClientOptions("POST", wireDetails);
      const url = AppSettings.ApiCustomWirePrice;
  
      const res = await fetch(url, options);
      await handleError(res);
      const data = await res.json();
      return data;
    }
    catch(err){
      console.log(err);
      return {};
    }
  }

  function createClientOptions(method, payload){
    const options = {
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-store',
        Authorization: `Bearer ${token}`
      },
      body: payload ? JSON.stringify(payload) : null
    };

    return options;
}
  
  return {
    fetchGasketPrice,
    fetchWirePrice,
  }
}



async function handleError(res){
  if (!res.ok) {
    const contentType = res.headers.get('Content-Type')

    let errorMessage

    if (contentType && contentType.includes('application/json')) {
      const errorData = await res.json()
      errorMessage = errorData.message
    } 
    else {
      errorMessage = await res.text()
    }

    errorMessage = errorMessage || res.statusText

    throw new Error(`${res.status}: ${errorMessage}`)
  }
  return res // return the res if handleError is being used in a component using Promise Chaining .then().catch()
}